<template>
    <div class="audio-player" @click="changeAudioState" v-if="audioSrc">
        <div class="audio-playing" v-if="audioState === 'playing'">
            <i></i>
            <i></i>
            <i></i>
            <i></i>
            <i></i>
        </div>
        <div class="audio-end" v-else></div>
    </div>
</template>
<script>
export default {
  name: 'audioBtn',
  computed: {
    audioState () {
      return this.$store.state.audioState
    },
    // 设置播放
    setPalyer () {
      return this.$store.state.autoPalyer
    },
    audioSrc () {
      return this.$store.state.audioSrc
    }
  },
  data () {
    return {

    }
  },
  mounted () {
    if (this.setPalyer) {
      this.$store.commit('setAutoPlayer', true)
    } else {
      this.$store.commit('setAutoPlayer', false)
      this.$store.commit('setAudioState', 'ended')
    }
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        // 页面被挂起
        this.$store.commit('setAutoPlayer', false)
      }
    })
  },
  methods: {
    changeAudioState () {
      this.$store.commit('setAutoPlayer', !this.setPalyer)
    }
  },
  beforeDestroy () {
    this.$store.commit('setAutoPlayer', false)
    this.$store.commit('setAudioState', 'ended')
  }
}
</script>
<style lang="less" scoped>
.audio-player{
    width: .45rem;
    height: .45rem;
    border-radius: 50%;
    border: .02rem solid #4FAA58;
    position: relative;
    margin-left: .3rem;
    transition: all 1s;
    overflow: hidden;
    .audio-end{
        width: 0;
        height: 0;
        border-left: .1rem solid transparent;
        border-right: .1rem solid transparent;
        border-bottom: .16rem solid #4FAA58;
        position: absolute;
        top: .15rem;
        left: .15rem;
        transform: rotate(90deg);
    }
    .audio-playing{
        display: flex;
        align-items: flex-end;
        justify-content: space-around;
        height: .3rem;
        margin: .045rem auto 0;
        width: .3rem;
        i{
            width: .02rem;
            background: #4FAA58;
        }
        i:nth-child(1){
            width: .02rem;
            animation: scaleAnmt 1.5s linear infinite;
        }
        i:nth-child(2){
            width: .02rem;
            animation: scaleAnmt2 1.5s linear infinite;
        }
        i:nth-child(3){
            width: .02rem;
            animation: scaleAnmt3 1.5s linear infinite;
        }
        i:nth-child(4){
            width: .02rem;
            animation: scaleAnmt4 1.5s linear infinite;
        }
        i:nth-child(5){
            width: .02rem;
            animation: scaleAnmt5 1.5s linear infinite;
        }
    }
}
@keyframes scaleAnmt {
    0%{
        height: .03rem;
    }
    50%{
        height: .2rem;
    }
    100%{
        height: .02rem;
    }
}
@keyframes scaleAnmt2 {
    0%{
        height: .1rem;
    }
    25%{
        height: .2rem;
    }
    75%{
        height: .02rem;
    }
    100%{
        height: .11rem;
    }
}
@keyframes scaleAnmt3 {
    0%{
        height: .2rem;
    }
    5%{
        height: .2rem;
    }
    58%{
        height: .01rem;
    }
    100%{
        height: .19rem;
    }
}
@keyframes scaleAnmt4 {
    0%{
        height: .03rem;
    }
    50%{
        height: .2rem;
    }
    100%{
        height: .02rem;
    }
}
@keyframes scaleAnmt5 {
    0%{
        height: .1rem;
    }
    25%{
        height: .2rem;
    }
    75%{
        height: .02rem;
    }
    100%{
        height: .11rem;
    }
}
</style>
